module.exports = __webpack_public_path__ + "img/kubernetes.0dc05e6b.png";